
export class IsiXmlAction {

    type: string;
    lnCv: string;
    ctrl: string;
    trig: string;
    val: string;

    constructor() {
        this.type = null;
        this.lnCv = null;
        this.ctrl = null;
        this.trig = null;
        this.val = null;
    }


}
